import ContactForm from '../components/ContactForm';
import Taskbar from '../components/Taskbar';
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";
 

function ContactPage() {
  return (
    <>
      <Taskbar />
      <TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="max-[942px]:pt-12 min-[942px]:mt-[51px] bg-card">
        <div className=" bg-opacity-90 pb-5 rounded transition-colors duration-500 w-full">
          <ContactForm />
        </div>
      </div>
      </TwoColumnLayout>
    </>
  );
}

export default ContactPage;
